<div class="row">
  <div class="card shadow-none rounded">
    <div class="card-body">
      <div class="col-12 col-md-12 col-xxl-12 col-xl-12">
        <div class="row">
          <div class="col-12 col-xxl-10 col-xl-10 col-md-10 col-lg-10 col-sm-8">
            <h4 class="fw-bold">Intangible fixed assets - {{commonService.headerName}}</h4>
          </div>
          <div class="col-12 col-xxl-2 col-xl-2 col-md-2 col-lg-2 col-sm-4 text-start text-sm-end p-sm-0 pt-2">
            <button type="button" class="btn btn-outline-themecolorlight" style="padding: 7px;font-weight: 600; font-size: 14px;" tabindex="-1" (click)="TotalBack()">Close Accounts</button>
          </div>
        </div>
      </div>
      <hr />

      <div class="col-12 col-md-12 col-xxl-12 col-xl-12 col-lg-12  col-sm-12">
        <form [formGroup]="CreateIntangibleFormGroup" >
          <div class="row">
            <div class="col-12 col-md-12 col-xxl-10 col-xl-12 col-lg-12  col-sm-12">
              <!--<h5 class="fw-bolder font-size-16">
                Intangible fixed assets
              </h5>-->
              <p class="text-dark mb-2">Please enter notes on  intangible fixed assets.</p>
              <p class="text-dark">If you do not have any notes to make, please return to the notes menu and de-select this section.</p>
            </div>
            <!--Cost-->
            <div class="col-12 col-md-12 col-xxl-10 col-xl-12 col-lg-12 col-sm-12 mt-2 p-0 p-lg-2">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <div class="row  flex-column-reverse flex-sm-row ">
                      <div class="col-md-6  col-sm-6 col-12">
                        <div class="pt-4 ">
                          <h6 class="fw-bolder "> Cost</h6>
                        </div>
                      </div>
                      <div class="col-md-6  col-sm-6 col-12">
                        <div class="mb-2 text-center">
                          <h6 class="mb-0 fw-bolder">{{commonService.StartYear}}</h6>
                          <label>({{commonService.CAPeriodFrom}} to {{commonService.CAPeriodTo}})</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 ps-5 ">
              <div class="form-group">
                <div class="row">
                  <div class="col-md-6  col-sm-6 col-12">
                    <div class="pt-2 mb-4">
                      <label class="m-t-5 font-weight-600">At {{commonService.StartDate}}</label>
                    </div>
                  </div>
                  <div class="col-md-6  col-sm-6 col-12">
                    <div class="input-group mb-3">
                      <div class="input-group-text">
                        <span class=" theme-color font-weight-600">£</span>
                      </div>
                      <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective maxlength="11" formControlName="IntangibleAssetsGrossCost_Start" placeholder="" (blur)="Calculations()"  />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-md-6  col-sm-6 col-12">
                    <div class="pt-2 mb-4">
                      <label class="m-t-5 font-weight-600">Additions</label>
                    </div>
                  </div>
                  <div class="col-md-6  col-sm-6 col-12">
                    <div class="input-group mb-3">
                      <div class="input-group-text">
                        <span class=" theme-color font-weight-600">£</span>
                      </div>
                      <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective maxlength="11" formControlName="TotalAdditionsIncludingFromBusinessCombinationsIntangibleAssets" placeholder="" (blur)="Calculations()" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-md-6  col-sm-6 col-12">
                    <div class="pt-2 mb-4">
                      <label class="m-t-5 font-weight-600">Disposals</label>
                    </div>
                  </div>
                  <div class="col-md-6  col-sm-6 col-12">
                    <div class="input-group mb-3">
                      <div class="input-group-text">
                        <span class=" theme-color font-weight-600">£</span>
                      </div>
                      <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective maxlength="11" formControlName="DisposalsIntangibleAssets" placeholder="" (blur)="Calculations()" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-md-6  col-sm-6 col-12">
                    <div class="pt-2 mb-4">
                      <label class="m-t-5 font-weight-600">At {{commonService.EndDate}}</label>
                    </div>
                  </div>
                  <div class="col-md-6  col-sm-6 col-12">
                    <div class="input-group mb-3">
                      <div class="input-group-text">
                        <span class=" theme-color font-weight-600">£</span>
                      </div>
                      <input type="text" class="form-control text-end AccountNumber" appNumberdirective maxlength="11" formControlName="IntangibleAssetsGrossCost_End" placeholder="" />
                    </div>
                  </div>
                </div>
              </div>

           </div>
          </div>
            </div>

            <!--Amortisation--> 
            <div class="col-12 col-md-12 col-xxl-10 col-xl-12 col-lg-12  col-sm-12 mt-2 p-0 p-lg-2">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <div class="row flex-column-reverse flex-sm-row ">
                      <div class="col-md-6  col-sm-12 col-12">
                        <div class="pt-2 mb-4">
                          <h6 class="fw-bolder "> Amortisation</h6>
                        </div>
                      </div>
                      <div class="col-md-6  col-sm-12 col-12">
                        <!--<div class="mb-2 text-center">
                          <h6 class="mb-0 fw-bolder">{{commonService.StartYear}}</h6>
                          <label>({{commonService.CAPeriodFrom}} to {{commonService.CAPeriodTo}})</label>
                        </div>-->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 ps-0 ps-5">
              <div class="form-group">
                <div class="row">
                  <div class="col-md-6  col-sm-6 col-12">
                    <div class="pt-2 mb-4">
                      <label class="m-t-5 font-weight-600">At {{commonService.StartDate}}</label>
                    </div>
                  </div>
                  <div class="col-md-6  col-sm-6 col-12">
                    <div class="input-group mb-3">
                      <div class="input-group-text">
                        <span class=" theme-color font-weight-600">£</span>
                      </div>
                      <input type="text"  class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective maxlength="11"  formControlName="AccumulatedAmortisationImpairmentIntangibleAssets_Start" placeholder="" (blur)="Calculations()" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-md-6  col-sm-6 col-12">
                    <div class="pt-2 mb-4">
                      <label class="m-t-5 font-weight-600">Provided during the period</label>
                    </div>
                  </div>
                  <div class="col-md-6  col-sm-6 col-12">
                    <div class="input-group mb-3">
                      <div class="input-group-text">
                        <span class=" theme-color font-weight-600">£</span>
                      </div>
                      <input type="text"  class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective maxlength="11"  formControlName="IncreaseFromAmortisationChargeForYearIntangibleAssets" placeholder="" (blur)="Calculations()" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-md-6  col-sm-6 col-12">
                    <div class="pt-2 mb-4">
                      <label class="m-t-5 font-weight-600">Disposals</label>
                    </div>
                  </div>
                  <div class="col-md-6  col-sm-6 col-12">
                    <div class="input-group mb-3">
                      <div class="input-group-text">
                        <span class=" theme-color font-weight-600">£</span>
                      </div>
                      <input type="text"  class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective maxlength="11"  formControlName="DisposalsDecreaseInAmortisationImpairmentIntangibleAssets" placeholder="" (blur)="Calculations()" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-md-6  col-sm-6 col-12">
                    <div class="pt-2 mb-4">
                      <label class="m-t-5 font-weight-600">At {{commonService.EndDate}}</label>
                    </div>
                  </div>
                  <div class="col-md-6  col-sm-6 col-12">
                    <div class="input-group mb-3">
                      <div class="input-group-text">
                        <span class=" theme-color font-weight-600">£</span>
                      </div>
                      <input type="text"  class="form-control text-end AccountNumber" appNumberdirective maxlength="11"  formControlName="AccumulatedAmortisationImpairmentIntangibleAssets_End" placeholder="" />
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </div>

            </div>

            <!--Net book value-->
            <div class="col-12 col-md-12 col-xxl-10 col-xl-12 col-lg-12  col-sm-12 mt-2 p-0 p-lg-2">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <div class="row flex-column-reverse flex-sm-row ">
                      <div class="col-md-6  col-sm-12 col-12">
                        <div class="pt-2 mb-4">
                          <h6 class="fw-bolder "> Net book value</h6>
                        </div>
                      </div>
                      <div class="col-md-6  col-sm-6 col-12">
                        <!--<div class="mb-2 text-center">
                          <h6 class="mb-0 fw-bolder">{{commonService.StartYear}}</h6>
                          <label>({{commonService.CAPeriodFrom}} to {{commonService.CAPeriodTo}})</label>
                        </div>-->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 ps-5">
              <div class="form-group">
                <div class="row">
                  <div class="col-md-6  col-sm-6 col-12">
                    <div class="pt-2 mb-4">
                      <label class="m-t-5 font-weight-600">At {{commonService.EndDate}}</label>
                    </div>
                  </div>
                  <div class="col-md-6  col-sm-6 col-12">
                    <div class="input-group mb-3">
                      <div class="input-group-text">
                        <span class=" theme-color font-weight-600">£</span>
                      </div>
                      <input type="text"  class="form-control text-end AccountNumber" appNumberdirective maxlength="11"  formControlName="IntangibleAssets_End" placeholder="" (blur)="Calculations()" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-md-6  col-sm-6 col-12" *ngIf="commonService.showControl==true">
                    <div class="pt-2 mb-4">
                      <label class="m-t-5 font-weight-600">At {{commonService.LastyearEndDate}}</label>
                    </div>
                  </div>
                  <div class="col-md-6  col-sm-6 col-12" *ngIf="commonService.showControl==true">
                    <div class="input-group mb-3">
                      <div class="input-group-text">
                        <span class=" theme-color font-weight-600">£</span>
                      </div>
                      <input type="text"  class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective maxlength="11"  formControlName="IntangibleAssets_Start" placeholder="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
              </div>
            </div>
            <!--<div class="col-12 col-xxl-10 col-xl-12 col-md-12 col-lg-12 col-sm-12">-->
              <!--Cost-->
              <!--<div class="row mb-3">
                <div class="col-12 col-xxl-6 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                  <div class="mb-3">
                    <h6 class="pt-3 mb-0 fw-bolder fw-bolder">
                      Cost
                    </h6>
                  </div>
                  <div class="mb-4">
                    <label>At 01 Jan 2017</label>
                  </div>
                  <div class="mb-4">
                    <label>
                      Additions
                    </label>
                  </div>
                  <div class="mb-4">
                    <label>
                      Disposals
                    </label>
                  </div>
                  <div class="mb-4">
                    <label>At 31 Dec 2017</label>
                  </div>

                </div>
                <div class="col-12 col-xxl-6 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                  <div class="mb-2 text-center">
                    <h6 class="mb-0 fw-bolder">{{commonService.StartYear}}</h6>
                    <label>({{commonService.CAPeriodFrom}} to {{commonService.CAPeriodTo}})</label>
                  </div>
                  <div class="mb-2">
                    <div class="input-group">
                      <div class="input-group-text ">£</div>
                      <input type="text" class="form-control AccountNumber" appNumberdirective   formControlName="IntangibleAssetsGrossCost_Start" placeholder="" (blur)="Calculations()" />
                    </div>
                  </div>
                  <div class="mb-2">
                    <div class="input-group">
                      <div class="input-group-text ">£</div>
                      <input type="text" class="form-control AccountNumber" appNumberdirective   formControlName="TotalAdditionsIncludingFromBusinessCombinationsIntangibleAssets" placeholder="" (blur)="Calculations()" />
                    </div>
                  </div>
                  <div class="mb-2">
                    <div class="input-group">
                      <div class="input-group-text ">£</div>
                      <input type="text" class="form-control AccountNumber" appNumberdirective   formControlName="DisposalsIntangibleAssets" placeholder="" (blur)="Calculations()" />
                    </div>
                  </div>
                  <div class="mb-2">
                    <div class="input-group">
                      <div class="input-group-text ">£</div>
                      <input type="text" class="form-control AccountNumber" appNumberdirective   formControlName="IntangibleAssetsGrossCost_End" placeholder="" />
                    </div>
                  </div>

                </div>
              </div>-->
              <!--Amortisation-->
              <!--<div class="row mb-3">
                <div class="col-12 col-xxl-6 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                  <div class="mb-3">
                    <h6 class="pt-3 mb-0 fw-bolder fw-bolder">
                      Amortisation
                    </h6>
                  </div>
                  <div class="mb-4">
                    <label>At 01 Jan 2017</label>
                  </div>
                  <div class="mb-4">
                    <label>
                      Provided during the period
                    </label>
                  </div>
                  <div class="mb-4">
                    <label>
                      Disposals
                    </label>
                  </div>
                  <div class="mb-4">
                    <label>At 31 Dec 2017</label>
                  </div>

                </div>
                <div class="col-12 col-xxl-6 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                  <div class="mb-2">
                    <div class="input-group">
                      <div class="input-group-text ">£</div>
                      <input type="text" class="form-control AccountNumber" appNumberdirective   formControlName="AccumulatedAmortisationImpairmentIntangibleAssets_Start" placeholder="" (blur)="Calculations()" />
                    </div>
                  </div>
                  <div class="mb-2">
                    <div class="input-group">
                      <div class="input-group-text ">£</div>
                      <input type="text" class="form-control AccountNumber" appNumberdirective   formControlName="IncreaseFromAmortisationChargeForYearIntangibleAssets" placeholder="" (blur)="Calculations()" />
                    </div>
                  </div>
                  <div class="mb-2">
                    <div class="input-group">
                      <div class="input-group-text ">£</div>
                      <input type="text" class="form-control AccountNumber" appNumberdirective   formControlName="DisposalsDecreaseInAmortisationImpairmentIntangibleAssets" placeholder="" (blur)="Calculations()" />
                    </div>
                  </div>
                  <div class="mb-2">
                    <div class="input-group">
                      <div class="input-group-text ">£</div>
                      <input type="text" class="form-control AccountNumber" appNumberdirective   formControlName="AccumulatedAmortisationImpairmentIntangibleAssets_End" placeholder="" />
                    </div>
                  </div>

                </div>
              </div>-->

              <!--Net book value-->
              <!--<div class="row mb-3">
                <div class="col-12 col-xxl-6 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                  <div class="mb-3">
                    <h6 class="pt-3 mb-0 fw-bolder fw-bolder">
                      Net book value
                    </h6>
                  </div>
                  <div class="mb-4">
                    <label>At 01 Jan 2017</label>
                  </div>

                  <div class="mb-4">
                    <label>At 31 Dec 2017</label>
                  </div>

                </div>
                <div class="col-12 col-xxl-6 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                  <div class="mb-2 text-center">
                    <h6 class="mb-0 fw-bolder">{{commonService.StartYear}}</h6>
                    <label>({{commonService.CAPeriodFrom}} to {{commonService.CAPeriodTo}})</label>
                  </div>
                  <div class="mb-2">
                    <div class="input-group">
                      <div class="input-group-text ">£</div>
                      <input type="text" class="form-control AccountNumber" appNumberdirective   formControlName="IntangibleAssets_End" placeholder="" (blur)="Calculations()" />
                    </div>
                  </div>
                  <div class="mb-2">
                    <div class="input-group">
                      <div class="input-group-text ">£</div>
                      <input type="text" class="form-control AccountNumber" appNumberdirective   formControlName="IntangibleAssets_LY" placeholder="" />
                    </div>
                  </div>-->
                  <!--<div class="mb-2">
          <div class="input-group">
            <div class="input-group-text ">£</div>
            <input type="text"  class="form-control text-end AccountNumber" appNumberdirective maxlength="11"  formControlName="IntangibleAssets_End" placeholder="" (blur)="Calculations()" />
          </div>
        </div>
        <div class="mb-2">
          <div class="input-group">
            <div class="input-group-text ">£</div>
            <input type="text"  class="form-control text-end AccountNumber" appNumberdirective maxlength="11"  formControlName="IntangibleAssets_End" placeholder="" />
          </div>
        </div>-->

                <!--</div>


              </div>
            </div>-->
          <div class="col-12 col-xxl-10 col-xl-12 col-md-12 col-lg-12 col-sm-12 mt-2 p-0 p-lg-2">

            <label class="pb-2">
              Please enter any additional information in the field below.
            </label>
            <div class="mb-3">
              <textarea class="form-control allowSpecialChars" [appTooltip]="showBubbledata" appNumberdirective maxlength="4000" formControlName="IntangibleAssetsFreeøtextComment" rows="6" required></textarea>
            </div>
          </div>
            <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 text-end mt-4">
              <button type="button" class="btn btn-outline-back p-1 ps-3 pe-3 me-2" (click)="On_Back()">Back</button>
              <button type="button" class="btn themedefault p-1 ps-3 pe-3 ms-1 me-0" (click)="On_Next()">Next</button>
            </div>
          </div>
        </form>
      </div>

    </div>
  </div>
</div>
